import { useQuery } from "@tanstack/react-query";
import { useToken } from "./use-token";
import { z } from "zod";
import { api } from "@/lib/server";

export function useActiveReservations() {
  const token = useToken();
  return useQuery({
    queryKey: ["active-reservations", token],
    enabled: !!token,
    queryFn: async () => {
      return await api.reservations.activesForUser();
    },
  });
}

export const resSchema = z.object({
  createdAt: z.string(),
  status: z.coerce.number(),
  paid: z.boolean(),
  datetime: z.string().transform((elem) => new Date(elem)),
  userId: z.coerce.number(),
  machineId: z.coerce.number(),
  originalPrice: z.coerce.number(),
  pricingRuleDiscount: z.coerce.number(),
  pricingRuleId: z.coerce.number().nullish(),
  storePlace: z.coerce.number().optional(),
  dryerBundleId: z.coerce.number().optional().nullish(),
});
